<template>
  <div class="all">
    <Navbar :user="user"></Navbar>
    <router-view :user="user"></router-view>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import Navbar from '../components/Navbar.vue';

export default {
  name: 'Front',
  data() {
    return {
      lastTime: '',
      user: {
        id: '',
        data: {
          photoURL: '',
        },
      },
    };
  },
  components: {
    Navbar,
  },
  methods: {
    LoginOrNot() {
      const vm = this;
      firebase.auth().onAuthStateChanged((userState) => {
        if (userState) {
          firebase.database().ref(`users/${userState.uid}`).on('value', (snapshot) => {
            vm.user.data = snapshot.val();
            vm.user.id = snapshot.key;
          });
        } else {
          vm.user.id = '';
        }
      });
    },
    getLastDate() {
      const vm = this;
      firebase.database().ref('resetDate/').once('value').then((snapshot) => {
        vm.lastTime = snapshot.val();
      })
        .then(() => {
          vm.resetDate();
        });
    },
    resetDate() {
      const vm = this;
      const now = new Date();
      const date = parseInt(now - new Date(vm.lastTime), 10) / 1000 / 3600 / 24;
      if (date >= 7) {
        const val = Math.floor(vm.getFirstDayOfWeek(now));
        firebase.database().ref('resetDate/').set(val);
        // console.log(now, val);
      } else {
        // console.log('error', now, date);
      }
    },
    getFirstDayOfWeek(date) {
      const day = date.getDay() || 7;
      return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1 - day);
    },
  },
  created() {
    this.LoginOrNot();
    this.getLastDate();
    // firebase.database().ref('resetDate/').set(1557878400000);
  },
};
</script>
